/**
 * Transforma um número em string com valor monetário
 * @param value R$ 0,00
 * @returns
 */
export const useToCurrency = (value: number | null | undefined) =>
  (value ?? 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
